/**
 * Get tracking tags for the grid layout.
 *
 * @param {Object} params - The parameters for the function.
 * @param {number} params.totalNumResults - The total number of results.
 * @param {string} params.cioFilterName - The name of the filter applied.
 * @param {string} params.cioFilterValue - The value of the filter applied.
 * @returns {Object} - An object containing the tracking tags.
 */
export const getGridLayoutTrackingTags = ({
  totalNumResults,
  cioFilterName,
  cioFilterValue,
}) => {
  const trackingTags = {
    'data-cnstrc-browse': '',
    'data-cnstrc-num-results': totalNumResults,
    'data-cnstrc-filter-name': cioFilterName,
    'data-cnstrc-filter-value': cioFilterValue,
    'data-autotag': 'prodgrid',
    'data-grid-version': 'CIO v1.1',
  };

  return {
    trackingTags,
  };
};
